import type { App } from "vue"
import type { ModuleDefinition, ModuleOptions } from "@core/types/module"

/**
 * Le module des alarmes V2 (« Surveillance »). Rien à installer : ses routes
 * sont lues par le générateur du routeur, ses services par celui des registres.
 */
const alarmesV2Module: ModuleDefinition = {
    name: "alarmes-v2",

    install(_app: App, _options: ModuleOptions): void {
        // Rien à initialiser : le module est caché tant que la garde serveur ne l'ouvre pas.
    },
}

export default alarmesV2Module
